export default __webpack_public_path__ + "static/media/img07.187e68bf.webp";